// @flow

import type { PropsSchema, BasicProps } from '../../type'

import * as React from 'react'
import css from './Image.scss'
import onClickEvents from '../hoc/onClickEvent'
import computeData from '../hoc/computeData'
import cx from 'classnames'

type Props = BasicProps & {
  style: { [string]: string },
  image: ?{
    url: string,
    originWidth: number,
    originHeight: number
  },
  url: string,
  noShowChildren: boolean,
  onClick: () => void,
  children: React.ChildrenArray<React.Node>
};

@computeData({ includeData: true, annotation: '//接收参数：url' })
@onClickEvents
export default class Image extends React.PureComponent<Props> {
  static schema: PropsSchema = [
    {
      type: 'style'
    },
    'separator',
    {
      type: 'image'
    },
    'separator',
    {
      key: 'url',
      type: 'text',
      title: 'URL'
    },
    {
      key: 'noShowChildren',
      type: 'boolean',
      title: '不显示子组件'
    }
  ];

  render () {
    const {
      id,
      style,
      image,
      children,
      onClick,
      visible,
      jsEnv,
      url,
      noShowChildren
    } = this.props
    if (!visible) {
      return null
    }
    const imgUrl =
      (url ? jsEnv.getString(url) : jsEnv.runCode('url')) ||
      (image && image.url)
    return (
      <div className={css.main} style={style} id={id} onClick={onClick}>
        <div style={{ lineHeight: 0, height: '100%' }}>
          {imgUrl && (
            <img
              src={imgUrl}
              style={{
                width: '100%',
                verticalAlign: 'middle',
                ...(style.height ? { height: '100%' } : {})
              }}
            />
          )}
        </div>
        {!noShowChildren && (
          <div className={cx(imgUrl && css.children)}>{children}</div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/basic/Image.js